/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} VenueInputs */

const th_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามแข่ง`)
};

const en_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue`)
};

const ja_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会場`)
};

const zh_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场馆`)
};

const es_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabellón`)
};

const pt_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásio`)
};

const id_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const fr_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle`)
};

const tl_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue`)
};

const vi_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm`)
};

const ko_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기장`)
};

const de_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halle`)
};

const ru_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадка`)
};

const tr_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salon`)
};

const it_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impianto`)
};

const pl_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hala`)
};

const uk_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майданчик`)
};

const hi_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थल`)
};

const ar_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصالة`)
};

const ms_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const bn_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাঠ`)
};

const zh_tw2_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館`)
};

const zh_hk2_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館`)
};

const ur_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقام`)
};

const fa_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سالن`)
};

const sw_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi`)
};

const nl_venue = /** @type {(inputs: VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaal`)
};

/**
* | output |
* | --- |
* | "Venue" |
*
* @param {VenueInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const venue = /** @type {((inputs?: VenueInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<VenueInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_venue(inputs)
	if (locale === "ja") return ja_venue(inputs)
	if (locale === "zh") return zh_venue(inputs)
	if (locale === "es") return es_venue(inputs)
	if (locale === "pt") return pt_venue(inputs)
	if (locale === "id") return id_venue(inputs)
	if (locale === "fr") return fr_venue(inputs)
	if (locale === "tl") return tl_venue(inputs)
	if (locale === "vi") return vi_venue(inputs)
	if (locale === "ko") return ko_venue(inputs)
	if (locale === "de") return de_venue(inputs)
	if (locale === "ru") return ru_venue(inputs)
	if (locale === "tr") return tr_venue(inputs)
	if (locale === "it") return it_venue(inputs)
	if (locale === "pl") return pl_venue(inputs)
	if (locale === "uk") return uk_venue(inputs)
	if (locale === "hi") return hi_venue(inputs)
	if (locale === "ar") return ar_venue(inputs)
	if (locale === "ms") return ms_venue(inputs)
	if (locale === "bn") return bn_venue(inputs)
	if (locale === "zh-TW") return zh_tw2_venue(inputs)
	if (locale === "zh-HK") return zh_hk2_venue(inputs)
	if (locale === "ur") return ur_venue(inputs)
	if (locale === "fa") return fa_venue(inputs)
	if (locale === "sw") return sw_venue(inputs)
	if (locale === "nl") return nl_venue(inputs)
	return en_venue(inputs)
});